export enum REDIRECT_PAGE {
  CREATE_NEW = 'create-new',
  CREATE_CAMPAIGN = 'create-campaign',
}
